// @core/api/endpoints/workflow/list_credentials.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListCredentialsResponse,
} from '../../../types/workflow';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/workflow';

/**
 * List credentials
 * Returns all credentials accessible in the current scope. Supports filtering by type.
 */
export async function ListCredentials(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListCredentialsResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/workflows/credentials`;
  const requestOptions = options;
  return client.get<ListCredentialsResponse>(requestPath, { ...requestOptions, params });
}
